'use strict';

var SortCustomizationDirective = function SortCustomizationDirective($timeout) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/sort-customization.html'),
    controller: 'SortCustomizationController',
    require: '^rmGridPanel',
    scope: {
      settings: '=',
      applyChangesCallback: '=',
      sortByCallback: '=',
      id: '@'
    },
    link: function link($scope, $element, attr, controller) {
      $scope.$on('grid:gridColumnsUpdated', function () {
        $timeout(function () {
          $scope.columns = $scope.settings.columns;
          $scope.initializeSortOptions();
        }, 0);
      });
      $scope.$on('grid:sorted', function (event, sortCriteria) {
        $scope.updateSortCriteria(sortCriteria);
      });
      $element.on('show.bs.modal', function () {
        $scope.isSortCustomizationShown = true;
        $timeout(function () {
          $scope.$evalAsync(function () {
            $scope.resetSortCriteriaTo(controller.getLastSortCriteriaApplied());
            $scope.resetIfDefaultSortCriteria();
            $scope._lastSortCriteria = $scope.sortCriteria.clone();
            $scope.$broadcast('rmCombobox:refresh');
          });
        }, 0);
      });
    }
  };
};
SortCustomizationDirective.$inject = ['$timeout'];
module.exports = SortCustomizationDirective;